<div class="auth-page">
  <div class="auth-content">
    @if (isShowLogo()) {
      <img class="auth-logo" src="assets/logo/logo.svg" aria-label="Company logo" />
    }

    <div class="auth-card">
      @if (isLoading()) {
        <div class="auth-card__overlay">
          <xemex-spinner size="sm"></xemex-spinner>
        </div>
      }
      <ng-content></ng-content>
    </div>

    <p class="auth-footer">
      {{ 'general.copyright' | translate: { year: currentYear, company: companyName } }}
    </p>
  </div>
</div>
